import {createAction, props} from '@ngrx/store';
import {ILocalPageOutputDto} from '@shared/interfaces/orga-response.interface';
import {
  AcceptEditorRequestDto,
  DeclineEditorRequestDto,
  MissionCompleteDto,
  MissionDto, MissionReportDto, MissionReportPreviewDto,
  LocationSimpleDto, MissionState, OpenEditorRequestOnContactListDto, ResourceDto, ResourceState,
  StereotypeSimpleDto,
} from '@server-models';
import {ISharedLocalBodyRequest} from "@shared/interfaces/shared-local-body-request.interface";

export const postMissionPagePaginated = createAction(
  '[Inventory-Tech] Post Mission Page Paginated Start',
  props<ISharedLocalBodyRequest>()
);

export const postMissionPagePaginatedCancel = createAction(
  '[Inventory-Tech] Post Mission Page Paginated Cancel'
);

export const postMissionPagePaginatedRefresh = createAction(
  '[Inventory-Tech] Post Mission Page Paginated Refresh',
  props<{ data: ILocalPageOutputDto<MissionCompleteDto[]> }>()
);

export const postMissionPagePaginatedSuccess = createAction(
 '[Inventory-Tech] Post Mission Page Paginated Success',
  props<{ data: ILocalPageOutputDto<MissionCompleteDto[]> }>()
);

export const postMissionPagePaginatedFail = createAction(
  '[Inventory-Tech] Post Mission Page Paginated Fail',
  props<{ error: Error }>()
);

// Mission detail
export const navigateToMissionDetail = createAction(
  '[Inventory-Tech] Navigate to Mission Detail',
  props<{ missionId: number }>()
);

export const getMissionDetailById = createAction(
  '[Inventory-Tech] Get Mission Detail Start',
  props<{ missionId: string; existingUrl: string[] }>()
);

export const getMissionDetailByIdSuccess = createAction(
  '[Inventory-Tech] Get Mission Detail Success',
  props<{ data: MissionDto; existingUrl: string[] }>()
);

export const getMissionDetailByIdFail = createAction(
  '[Inventory-Tech] Get Mission Detail Fail',
  props<any>()
);

export const getMissionDetailByIdDone = createAction(
  '[Inventory-Tech] Get Mission Detail Done'
);

export const setMissionState = createAction(
  '[Inventory-Tech] Set Mission State Start',
  props<{ id: number; stateToChange: MissionState; reason: string | null }>()
);

export const setMissionStateSuccess = createAction(
  '[Inventory-Tech] Set Mission State Success',
  props<{ missionState: MissionState }>()
);

export const setMissionStateFail = createAction(
  '[Inventory-Tech] Set Mission State Fail',
  props<{ error: any }>()
);

export const replanMission = createAction(
  '[Inventory-Tech] Replan Mission',
  props<{ missionId: number; actualStart: string; actualEnd: string }>()
);

export const replanMissionSuccess = createAction(
  '[Inventory-Tech] Replan Mission Success'
);

export const replanMissionFail = createAction(
  '[Inventory-Tech] Replan Mission Fail',
  props<{ error: any }>()
);

// Mission report getMissionReportById
export const getMissionReportById = createAction(
  '[Inventory-Tech] Get Mission Report Start',
  props<{ reportId: string }>()
);

export const getMissionReportByIdSuccess = createAction(
  '[Inventory-Tech] Get Mission Report Success',
  props<{ data: MissionReportDto }>()
);

export const getMissionReportByIdFail = createAction(
  '[Inventory-Tech] Get Mission Report Fail',
  props<{ error: any }>()
);

export const getMissionReportByIdDone = createAction(
  '[Inventory-Tech] Get Mission Report Done',
  props<{ a: any }>()
);

export const getMissionReportPreviewById = createAction(
  '[Inventory-Tech] Get Mission Preview Report Start',
  props<{ missionId: string }>()
);

export const getMissionReportPreviewByIdReset = createAction(
  '[Inventory-Tech] Get Mission Preview Report Reset'
);

export const missionReportDataReset = createAction(
  '[Inventory-Tech] Mission Report Data Reset'
);

export const getMissionReportPreviewByIdSuccess = createAction(
  '[Inventory-Tech] Get Mission Preview Report Success',
  props<{ data: MissionReportPreviewDto }>()
);

export const getMissionReportPreviewByIdFail = createAction(
  '[Inventory-Tech] Get Mission Preview Report Fail',
  props<{ error: any }>()
);

export const getMissionReportPreviewByIdDone = createAction(
  '[Inventory-Tech] Get Mission Preview Report Done',
  props<{ a: any }>()
);

export const navigateToInventory = createAction(
  '[Inventory-Tech] Navigate To Inventory'
);

export const missionNavigateDone = createAction(
  '[Inventory-Tech] Mission navigation done'
)

// Mission report article list
export const getMissionReportArticleList = createAction(
  '[Inventory-Tech] Get Mission Report Article Paginated Start',
  props<{ searchTerm?: string, restrictions?: StereotypeSimpleDto[] }>()
);

export const getMissionReportArticleListSuccess = createAction(
  '[Inventory-Tech] Get Mission Report Article Paginated Success',
  props<{ data: any }>()
);

export const getMissionReportArticleListFail = createAction(
  '[Inventory-Tech] Get Mission Report Article Paginated Fail',
  props<{ error: any }>()
);

export const submitMissionReport = createAction(
  '[Inventory-Tech] Submit Mission Report Start',
  props<{ missionReport: MissionReportDto; hasReportId: boolean, formattedData: any }>()
);

export const submitMissionReportSuccess = createAction(
  '[Inventory-Tech] Submit Mission Report Success',
  props<{ response: MissionReportDto; hasReportId: boolean }>()
);

export const submitMissionReportFail = createAction(
  '[Inventory-Tech] Submit Mission Report Fail',
  props<{ error: any; formData: MissionReportDto }>()
);

// mission requested
export const postMissionRequestedPagePaginated = createAction(
  '[Inventory-Tech] Post Mission Requested Page Paginated Start',
  props<ISharedLocalBodyRequest>()
);

export const postMissionRequestedPagePaginatedCancel = createAction(
  '[Inventory-Tech] Post Mission Requested Page Paginated Cancel'
);

export const postMissionRequestedPagePaginatedRefresh = createAction(
  '[Inventory-Tech] Post Mission Requested Page Paginated Refresh',
  props<{ data: ILocalPageOutputDto<OpenEditorRequestOnContactListDto[]> }>()
);

export const postMissionRequestedPagePaginatedSuccess = createAction(
  '[Inventory-Tech] Post Mission Requested Page Paginated Success',
  props<{ data: ILocalPageOutputDto<OpenEditorRequestOnContactListDto[]> }>()
);

export const postMissionRequestedPagePaginatedFail = createAction(
  '[Inventory-Tech] Post Mission Requested Page Paginated Fail',
  props<{ error: Error }>()
);

// requested mission editorQuest

export const postMissionEditorQuestAccept = createAction(
  '[Inventory-Tech] Post Mission EditorQuest Accept',
  props<{ missionId: number; body: AcceptEditorRequestDto }>()
);

export const postMissionEditorQuestAcceptFail = createAction(
  '[Inventory-Tech] Post Mission EditorQuest Accept Fail',
  props<{ error: any }>()
);

export const postMissionEditorQuestDecline = createAction(
  '[Inventory-Tech] Post Mission EditorQuest Decline',
  props<{ missionId: number; body: DeclineEditorRequestDto }>()
);

export const postMissionEditorQuestDeclineFail = createAction(
  '[Inventory-Tech] Post Mission EditorQuest Decline Fail',
  props<{ error: any }>()
);

export const postMissionEditorQuestDone = createAction(
  '[Inventory-Tech] Post Mission EditorQuest Done',
  props<{ answer: DeclineEditorRequestDto | AcceptEditorRequestDto; isDeclined: boolean }>()
);

// resource
export const navigateToResourceDetail = createAction(
  '[Inventory-Tech] Navigate to Resource Detail',
  props<{ resourceId: any }>()
);

export const getResourceDetailById = createAction(
  '[Inventory-Tech] Get Resource Detail Start',
  props<{ resourceId: string; existingUrl: string[] }>()
);

export const getResourceDetailByIdSuccess = createAction(
  '[Inventory-Tech] Get Resource Detail Success',
  props<{ data: ResourceDto; existingUrl: string[] }>()
);

export const getResourceDetailByIdFail = createAction(
  '[Inventory-Tech] Get Resource Detail Fail',
  props<{ error: any }>()
);

export const setResourceState = createAction(
  '[Inventory-Tech] Set Resource State Start',
  props<{ resourceId: number; state: ResourceState }>()
);

export const setResourceStateSuccess = createAction(
  '[Inventory-Tech] Set Resource State Success',
  props<{ resourceId: number; state: ResourceState }>()
);

export const setResourceStateFail = createAction(
  '[Inventory-Tech] Set Resource State Fail',
  props<{ resourceId: number; error: any }>()
);

export const setResourceLocation = createAction(
  '[Inventory-Tech] Set Resource Location Start',
  props<{ resourceId: number; state: ResourceState; location: LocationSimpleDto }>()
);

export const setResourceLocationSuccess = createAction(
  '[Inventory-Tech] Set Resource Location Success',
  props<{ resourceId: number; location: LocationSimpleDto }>()
);

export const setResourceLocationFail = createAction(
  '[Inventory-Tech] Set Resource Location Fail',
  props<{ resourceId: number; error: any }>()
);

// resource missions
export const getResourceDetailByIdMissionsPaginated = createAction(
  '[Inventory-Tech] Get Resource Detail Missions Paginated Start',
  props<{ request: ISharedLocalBodyRequest; resourceId: number }>()
);

export const getResourceDetailByIdMissionsPaginatedCancel = createAction(
  '[Inventory-Tech] Get Resource Detail Missions Paginated Cancel'
);

export const getResourceDetailByIdMissionsPaginatedRefresh = createAction(
  '[Inventory-Tech] Get Resource Detail Missions Paginated Refresh',
  props<{ data: ILocalPageOutputDto<MissionCompleteDto[]>; }>()
);

export const getResourceDetailByIdMissionsPaginatedSuccess = createAction(
  '[Inventory-Tech] Get Resource Detail Missions Paginated Success',
  props<{ data: ILocalPageOutputDto<MissionCompleteDto[]>}>()
);

export const getResourceDetailByIdMissionsPaginatedFail = createAction(
  '[Inventory-Tech] Get Resource Detail Missions Paginated Fail',
  props<{ error: any }>()
);

export const reportGoogleAPILoaded = createAction(
  '[Inventory-Tech] Report Google API Loaded'
);

export const getArticleRestrictions = createAction(
  '[Inventory-Tech] Get Article Restrictions',
  props<{ missionId: number; stereotypeId: number }>()
);

export const getArticleRestrictionsSuccess = createAction(
  '[Inventory-Tech] Get Article Restrictions Success',
  props<{ restrictions: StereotypeSimpleDto[] }>()
);

export const keepLastScrollTopPosition = createAction(
  '[Inventory-Tech] Keep Last Scroll Top Position',
  props<{ scrollTop: number }>()
)

export const keepTodayViewState = createAction(
  '[Inventory-Tech] Keep Today View State',
  props<{ date?: string; scrollTop?: number }>()
)
